import Rellax from 'rellax';
import Viewport from 'common/utils/viewport';

export default class RellaxElements {
    constructor(elements) {
        this.elements = elements;
        this.viewport = new Viewport();
        this.initialised = false;
        this.instances = [];

        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.initialise = this.initialise.bind(this);
        this.destroy = this.destroy.bind(this);

        this.viewport.on('change', this.handleViewportChange);

        if (this.viewport.inSize(['normal', 'large'])) {
            this.initialise();
        }
    }

    initialise() {
        this.initialised = true;
        this.instances = Array.from(this.elements).map((element, index) => {
            const speed = element.getAttribute('data-rellax');

            element.setAttribute('data-rellax-id', index);

            // Reset existing inline styles to avoid doubling up
            element.style.cssText = '';

            return new Rellax(`[data-rellax-id="${index}"]`, {
                speed: speed,
            });
        });
    }

    destroy() {
        this.initialised = false;

        this.instances.forEach(instance => {
            instance.destroy();
        });

        this.instances = [];
    }

    handleViewportChange() {
        if (this.viewport.inSize(['normal', 'large']) && !this.initialised) {
            this.initialise();
        } else if (this.viewport.inSize(['small', 'medium']) && this.initialised) {
            this.destroy();
        }
    }
}



// WEBPACK FOOTER //
// ./js/marketing/utils/RellaxElements.js